import Vue from 'vue'
import Vuex from 'vuex'
 
Vue.use(Vuex)
import cellCollection from './cellCollection'
import diseaseCollection from './diseaseCollection'

const store = new Vuex.Store({
  state: {
    detailData: []
  },
  mutations: {
    setDetailData(state,value){
      state.detailData = value;
    }
  },
  actions: {
  },
  modules: {
    cellCollection,
    diseaseCollection
  }
});

export default store;